export function getRoomNumberFromUrl(url: string) {
  const parsedUrl = new URL(url);
  const roomNumber = parsedUrl.hash.replace("#", "").split("=")[1];

  return roomNumber;
}
